import merge from 'deepmerge';
import Rollbar from 'rollbar';

// src/config/rollbar.ts

// src/config/ignoredErrorMessages.ts
var ignoredErrorMessages = [
  "Script error",
  // Minified React error gate
  "Minified React error #418",
  "Minified React error #423",
  "Minified React error #425",
  // Errors triggering thousands of times a day
  "Mixpanel is not initialised",
  "ResizeObserver loop"
];

// src/config/rollbar.ts
function createRollbarConfig({
  accessToken,
  enabled,
  userId,
  environment = "production",
  codeVersion = ((_a) => (_a = process == null ? void 0 : process.env) == null ? void 0 : _a.ROLLBAR_CODE_VERSION)(),
  blacklistedErrors = ignoredErrorMessages,
  sourceMapEnabled = false,
  configOverwrite
}) {
  const config = {
    accessToken,
    captureUncaught: true,
    scrubTelemetryInputs: true,
    captureUnhandledRejections: true,
    enabled,
    payload: {
      environment,
      ...userId ? {
        person: {
          id: userId
        }
      } : {},
      client: {
        javascript: {
          code_version: codeVersion,
          source_map_enabled: sourceMapEnabled,
          guess_uncaught_frames: true
        }
      }
    },
    ignoredMessages: blacklistedErrors
  };
  if (configOverwrite) {
    return merge(config, configOverwrite);
  }
  return config;
}
var createRollbarInstance = (props) => new Rollbar(createRollbarConfig(props));
var createOrConfigureRollbarInstanceOnWindow = (props) => {
  if (!window.Rollbar) {
    window.Rollbar = createRollbarInstance(props);
  } else if (props.userId) {
    window.Rollbar.configure({
      payload: {
        person: {
          id: props.userId
        }
      }
    });
  }
};

export { createOrConfigureRollbarInstanceOnWindow, createRollbarConfig, createRollbarInstance };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map